'use strict';



import $http from 'middleware/http';
import Components from './components/_index';
import Directives from './directives/_index';
import Load       from './util/load';



const PREFIX_SETTING = {
  componentPrefix: 'dn',
  directivePrefix: '',
};



function plugin(Vue) {

  // Directives
  Object.keys(Directives).forEach(key => {
    Vue.directive(`${PREFIX_SETTING.directivePrefix}${key}`, Directives[key])
  });

  // Components
  Object.keys(Components).forEach(key => {
    Vue.component(`${PREFIX_SETTING.componentPrefix}${key}`, Components[key])
  });

  Vue.prototype.$dn = {
    load: Load,
    blurActiveElement: blurActiveElement,
    sleep(ammount) { return new Promise(resolve => setTimeout(resolve, ammount) ) },
    // get config() { return _dn.config },
    // get path() { return _dn.path },
  };

  Vue.prototype.$scrollToTop = function() {
    blurActiveElement();
    return this.$scrollTo(document.body);
  }

  function blurActiveElement() {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  // Global Methods
  Vue.prototype.$delay = function(ammount) {
    let canceled  = false,
        canceller = () => { canceled = true }

    const promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!this._isDestroyed && !canceled) resolve();
      }, ammount);
    });

    return {
      cancel : canceller,
      promise: promise,
    }
  }

  Vue.prototype.$confirm = function(opt) {
    return dn.$refs.confirmDialog.show(opt);
  }

  Vue.prototype.$alert = function(opt) {
    return dn.$refs.alertDialog.show(opt);
  }

  // @TODO : ちゃんとファイルわける
  const $ls = {
    get(keyMap, defaultValue) {
      return dn.$store.getters['ls/at'](keyMap, defaultValue);
    },
    set(keyMap, value) {
      return dn.$store.dispatch('ls/set', {keyMap, value});
    },
    delete(keyMap) {
      return dn.$store.dispatch('ls/delete', keyMap);
    },
  };

  Vue.prototype.$ls = $ls;

  const $status = {
    display(id, divider) {
      return dn.$store.getters['status/displayAt'](id, divider);
    },
  }
  Vue.prototype.$status = $status;
  Vue.prototype.$http = $http;
}



export default plugin;



// WEBPACK FOOTER //
// ./src/js/ui/index.js